import controller from "./controller";

const modul = angular
    .module("Location", [])

    .controller("locationController", controller);

export default modul.name;
